"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Controls
 */
require("./extenders/controls/range-slider");
require("./extenders/controls/icon-picker");
require("./extenders/controls/text-editor");
require("./extenders/controls/toggle");
require("./extenders/controls/color-picker");
require("./extenders/controls/customizer-navigation");
require("./extenders/controls/image");
require("./extenders/controls/typography");
require("./extenders/controls/color-schemes");
require("./extenders/controls/upsell");
require("./extenders/controls/layouts");
require("./extenders/controls/repeater");
require("./extenders/controls/section-repeater");
require("./extenders/controls/button-group");
/**
 * Panels
 */
require("./extenders/panels/regular");
/**
 * Sections
 */
require("./extenders/sections/section-doubled");
require("./extenders/sections/section-pro");
require("./extenders/sections/recommended-actions");



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/customizer.ts
// module id = 42
// module chunks = 0